<template>
  <div class="flex-header-section">
    <select-all-search-header class="flex-header main-checkbox" />
    <div class="flex-header ">
      <span>ID</span>
    </div>
    <div class="flex-header">
      <span>Topic</span>
    </div>
    <div class="flex-header">
      <span>Products</span>
    </div>
    <div class="flex-header">
      <span>Actions</span>
    </div>
  </div>
</template>

<script>
import SelectAllSearchHeader from '../shared/SelectAllSearchHeader'

export default {
  components: { SelectAllSearchHeader }
}
</script>
